
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 32 32","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M28 8.578V32H4V0h15.422L28 8.578zM20 8h4.578L20 3.422V8zm6 22V10h-8V2H6v28h20zm-12-8h4v6h-4v-6zm-6-4h4v10H8V18zm12-4h4v14h-4V14z"}})])
          )
        }
      }
    